module.exports = __webpack_public_path__ + "static/media/radiobutton-01.c837a09b.png";